/* index.js */

"use strict";

const _ = require("lodash");
const {escapeHtml} = require("@gluenetworks/dom_utilities");

const {labelByTypeData} = require("../CustomFieldsConstants");

module.exports = {
    checkboxFormatter,
    dataTypeFormatter,
    typeInfoFormatter,
    descriptionFormatter,
    defaultValueFormatter,
    deleteButtonFormatter,
    nameFormatter,
    plainTextFormatter,
};

function plainTextFormatter(row, cell, value /*, columnDef, dataContext*/) {
    const text = document.createElement("div");
    text.setAttribute("title", value || "");
    text.classList.add("plain-text");
    text.innerText = value || "";
    return text.outerHTML;
}

function checkboxFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(true);
    }
    return checkbox.outerHTML;
}
function dataTypeFormatter(row, cell, value, columnDef, dataContext) {
    return labelByTypeData(value, dataContext.typeInfo) || "";
}

function descriptionFormatter(row, cell, value /*, columnDef, dataContext*/) {
    const description = document.createElement("div");
    description.setAttribute("title", value);
    description.classList.add("description");
    description.innerText = value || "";
    return description.outerHTML;
}

function nameFormatter(row, cell, value /*, columnDef, dataContext*/) {
    const name = document.createElement("div");
    name.setAttribute("title", value);
    name.classList.add("name");
    name.innerText = value || "";
    return name.outerHTML;
}

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    const button = document.createElement("base-icon-gl");
    button.dataset.icon = "common.trash_bin";
    button.setDarkTheme(true);

    button.setAttribute("aria-label", `delete ${dataContext.name}`);
    button.setAttribute("role", "button");

    button.dataset.uuid = dataContext.id;
    button.dataset.action = "delete";

    return button.outerHTML;
}

const DATA_TYPES = {
    String: stringTypeFormatter,
    Number: numberTypeFormatter,
    Enum: enumTypeFormatter,
    Boolean: () => "",
};

function typeInfoFormatter(row, cell, value, columnDef, dataContext) {
    const dataType = dataContext.dataType || "";
    const typeInfoValue = value || "";

    const typeFormatter = DATA_TYPES[dataType];

    return typeFormatter
        ? `<div class="type-info type-${escapeHtml(dataType)}">${typeFormatter(
              typeInfoValue || {}
          )}</div>`
        : "";
}

/**
 *
 * @param {Object}   enumTypeInfo
 * @param {string[]} [enumTypeInfo.ids]         - list of enum Ids
 * @param {string[]} [enumTypeInfo.labels]      - list of enum labels
 * @param {boolean}  [enumTypeInfo.multiSelect] - multi-select flag
 * @returns {string} - HTML markup string
 */
function enumTypeFormatter(enumTypeInfo) {
    const multiSelect = Boolean(enumTypeInfo.multiSelect);
    let labels = enumTypeInfo.labels || [];
    const valueSpan = document.createElement("span");

    labels = labels.join(", ");
    valueSpan.setAttribute("title", labels);
    valueSpan.innerText = labels;

    const hasInfo = labels.length;
    const info = [
        multiSelect && `<span class="boolean-state">Multiple</span>`,
        labels &&
            `<span class="values-list" title="${escapeHtml(labels)}">${escapeHtml(labels)}</span>`,
    ]
        .filter(Boolean)
        .join("<br />");

    return hasInfo ? info : "";
}

/**
 *
 * @param {Object}  numberTypeInfo
 * @param {Object}  [numberTypeInfo.Number]             - number type info object
 * @param {number}  [numberTypeInfo.Number.max]         - max value for number type
 * @param {number}  [numberTypeInfo.Number.min]         - min value for number type
 * @param {boolean} [numberTypeInfo.Number.onlyInteger] - min value for number type
 * @returns {string} - HTML markup string
 */
function numberTypeFormatter(numberTypeInfo) {
    const data = numberTypeInfo.Number || {};
    const onlyInteger = Boolean(data.onlyInteger);

    const hasInfo = Number.isFinite(data.min) || Number.isFinite(data.max) || onlyInteger;
    const info = [
        onlyInteger &&
            `<span title="is Integer" class="boolean-state">${
                onlyInteger ? "Integers only" : ""
            }</span>`,
        Number.isFinite(data.min) && `<span title="${data.min}">min: ${data.min}</span>`,
        Number.isFinite(data.max) && `<span title="${data.min}">max: ${data.max}</span>`,
    ]
        .filter(Boolean)
        .join("<br />");
    return hasInfo ? info : "";
}

/**
 *
 * @param {Object} stringTypeInfo
 * @param {Object} [stringTypeInfo.String]         - string type info object
 * @param {string} [stringTypeInfo.String.pattern] - regexp validation pattern
 * @returns {string} - HTML markup string
 */
function stringTypeFormatter(stringTypeInfo) {
    const data = stringTypeInfo.String || {};
    const hasInfo = data.pattern;

    const info = `
        <div>Pattern: </div>
        <span title="${escapeHtml(data.pattern)}">${escapeHtml(data.pattern)}</span>
    `;
    return hasInfo ? info : "";
}

function defaultValueFormatter(row, cell, value, columnDef, dataContext) {
    const {dataType, typeInfo: {ids = [], labels = []} = {}} = dataContext;
    let outputValue = _.isUndefined(value) ? "" : String(value);

    if (dataType === "Boolean") {
        return outputValue.toUpperCase();
    }

    if (dataType === "Enum") {
        outputValue = []
            .concat(value)
            .map((id) => labels[ids.indexOf(id)])
            .join(", ");
    }
    const span = document.createElement("span");
    span.classList.add("default-value");
    span.setAttribute("title", outputValue);
    span.innerText = outputValue;

    return span.outerHTML;
}
